/* eslint-disable import/prefer-default-export */
import { getGraph } from '@src/utils/redux.tools'
import { defaultState, AccessGraphState } from './default.state'
import type * as Actions from '@src/redux/actions/access.graph.actions'
import * as ActionTypes from '@src/redux/actionTypes/accessGraph.action.types'

export function reducer(
  state = defaultState,
  action: Actions.ActionTypes
): AccessGraphState {
  switch (action.type) {
    case ActionTypes.GET_STAT_SUCCESS: {
      return {
        ...state,
        [action.payload.stat]: action.payload.value,
        isPending: false
      }
    }

    case ActionTypes.GET_GRAPH_STAT_SUCCESS: {
      const { graph } = action.payload
      return {
        ...state,
        ...getGraph({ state, graph }),
        isPending: false
      }
    }

    case ActionTypes.SERVER_ERRORS: {
      return {
        ...state,
        errors: action.payload.errors,
        isPendingGraph: false
      }
    }

    case ActionTypes.REQUEST_PENDING: {
      return {
        ...state,
        isPending: action.payload.isPending
      }
    }

    case ActionTypes.REQUEST_PENDING_GRAPH: {
      return {
        ...state,
        isPendingGraph: action.payload.isPending
      }
    }

    default: {
      return state
    }
  }
}
